import { useState } from 'react';
import '../assets/styles/board.css';
import EndGame from './EndGame';
import {ReactComponent as ImgClose} from '../assets/images/close.svg';
import {ReactComponent as ImgCircle} from '../assets/images/circle-line.svg';
import { winner } from '../helper/winner';

const Board = ({names, setScreen, currentPlayer, setCurrentPlayer, history, setHistory, score, setScore}) => {
  // Generate new array 3x3 filled with E - for empty
  const generateTilesArray = () => {
    return Array(3).fill(Array(3).fill('E'));
  }
  // Take inputs into this array to follow game
  const [tilesArray, setTilesArray] = useState(() => generateTilesArray());
  const [occupiedField, setOccupiedField] = useState(false);
  const [winnerStatus, setWinnerStatus] = useState(0);
  const [showEndGameModal, setShowEndGameModal] = useState(false);

  // Handle mouse clicks and set new state
  const handleClick = (e) => {
    // Get field number from class name 0-8
    const el = e.target.className.baseVal[9];
    let newTilesArray = [];
    let newLineArray = [];
    // Calculate line (i) and row (j)
    const i = Math.floor(el / 3);
    const j = el % 3;
    // Check, if clicked field is empty or not
    // Undefined check is for event on clicking on existing X or O svg element and doesn't return
    // right answer of position, which still is event of occupied field
    if (typeof(el) === 'undefined' || tilesArray[i][j] !== 'E') {
      // And show message to click unoccupied field
      setOccupiedField(true)
    } else if (winnerStatus !== 0) {
      // pass
    } else {
      // Check, if on previus attempt was occupied field and remove message
      if (occupiedField) {setOccupiedField(false)};
      // Go through array copying unmodified field and modify clicked field
      for (let a=0; a<3; a++){
        // If changed field is not in this line, copy whole line
        if (i !== a) {newTilesArray.push(tilesArray[a])}
        else {
          for (let b=0; b < 3; b++) {
            // If changed field is not in this row, copy field
            if (j !== b) {newLineArray.push(tilesArray[a][b])}
            else if (currentPlayer === 0) {
              newLineArray.push('X');
              setCurrentPlayer(1);
            } else {
              newLineArray.push('O');
              setCurrentPlayer(0);
            }
          }
          newTilesArray.push(newLineArray);
        }
      }
      setTilesArray(newTilesArray);
      checkForWinner(newTilesArray);
    }
  }  

  // Check for winner
  const checkForWinner = (newTilesArray) => {
    let tempWinner = winner(newTilesArray);
    if (tempWinner === 1) {
      setScore({
        ...score,
        player1: score.player1 + 1
      })
    } else if (tempWinner === 2) {
      setScore({
        ...score,
        player2: score.player2 + 1
      })
    } else if (tempWinner === 3) {
      setScore({
        ...score,
        ties: score.ties + 1
      })
    };
    if (tempWinner !== 0) {
      setWinnerStatus(tempWinner);
      addGameToHistory(tempWinner);
      setShowEndGameModal(true);
    };
  }

  const addGameToHistory = (tempWinner) => {
    let nextID = history.length + 1;
    let d = new Date();
    let newGame = {};
    newGame.id = nextID;
    newGame.date = `${('0'+d.getDate()).slice(-2)}.${('0'+(d.getMonth()+1)).slice(-2)} ${('0'+d.getHours()).slice(-2)}:${('0'+d.getMinutes()).slice(-2)}`;
    newGame.player1 = names.player1;
    newGame.player2 = names.player2;
    switch (tempWinner) {
      case 1:
        newGame.winner = names.player1;
        break;
      case 2:
        newGame.winner = names.player2;
        break;
      case 3:
        newGame.winner = 'draw';
        break;
      default:
        break;
    }
    setHistory([
      ...history,
      newGame
    ])
  }

  const newGameStart = () => {
    setTilesArray(generateTilesArray());
    setOccupiedField(false);
    setWinnerStatus(0);
    setShowEndGameModal(false);
    setCurrentPlayer(0);
  }

  return (
    <div className="board" >
      {tilesArray.map((row, i) => {
        return (
          <div key={`row${i}`} className='row' >
            {
              row.map((el, j) => {
                return  <svg key={i*3+j} className={`tile tile${i*3+j}`} onClick={handleClick} viewBox='-30 -30 200 200' >
                         {(el === 'X') && <ImgClose className='orange' />}
                         {(el === 'O') && <ImgCircle className='blue' />}
                        </svg>
              })
            }
            <br/>
          </div>
        )
      })}
      {(occupiedField) && <div className='occupied'>Choose unoccupied cell!</div>}
      {(showEndGameModal) && <EndGame names={names} winnerStatus={winnerStatus} newGameStart={newGameStart}
                                      history={history} setScreen={setScreen} />}
    </div> 
  );
}

export default Board;